"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerOrderApi = require("@/api/customerOrderApi");
var _shopIntegralApi = require("@/api/shopIntegralApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var emptyDetailUser = function emptyDetailUser() {
  return {
    name: '',
    phone: '',
    customerName: '',
    sourceAppName: '',
    availablePoints: '',
    pendingIntegral: '',
    totalEarned: '',
    totalConsumed: '',
    totalRefundIntegral: '',
    totalRecycleIntegral: ''
  };
};

/** datetimerange：结束日在日历上点选时即带 23:59:59，不必等点面板「确定」后再靠脚本改 */
var DETAIL_DATE_RANGE_DEFAULT_TIME = ['00:00:00', '23:59:59'];
var _default = exports.default = {
  name: 'UserPointsManage',
  data: function data() {
    return {
      DETAIL_DATE_RANGE_DEFAULT_TIME: DETAIL_DATE_RANGE_DEFAULT_TIME,
      query: {
        keyword: '',
        customerId: null,
        changeType: ''
      },
      miniAppOptions: [],
      miniAppLoading: false,
      listLoading: false,
      tableData: [],
      serverTotal: 0,
      pageData: {
        page: 1,
        limit: 10
      },
      detailVisible: false,
      /** 当前抽屉对应的用户：detailStat / detailPage 共用 */
      detailContext: {
        customerId: null,
        userPhone: ''
      },
      detailStatLoading: false,
      detailDetailLoading: false,
      detailUser: emptyDetailUser(),
      detailQuery: {
        serialKeyword: '',
        dateRange: null,
        changeType: null
      },
      detailTableData: [],
      detailServerTotal: 0,
      detailPage: {
        page: 1,
        limit: 10
      }
    };
  },
  computed: {
    listTotal: function listTotal() {
      return this.serverTotal;
    },
    displayTableData: function displayTableData() {
      return this.tableData;
    },
    detailTableDisplay: function detailTableDisplay() {
      return this.detailTableData;
    },
    detailListTotal: function detailListTotal() {
      return this.detailServerTotal;
    }
  },
  created: function created() {
    this.searchMiniAppOptions('');
    this.loadList();
  },
  methods: {
    /**
     * 与 v-model 的 input 同步：同一天且结束仍为 00:00:00（或与开始完全相同）时补全为 23:59:59；
     * 用户已选其它结束时刻则不动。配合 default-time，日历点选结束日即可得到当天结束时刻。
     */
    onDetailDateRangeInput: function onDetailDateRangeInput(val) {
      var _this = this;
      if (!val || !Array.isArray(val) || val.length !== 2 || !val[0] || !val[1]) return;
      var _val = _slicedToArray(val, 2),
        start = _val[0],
        end = _val[1];
      var startDate = start.slice(0, 10);
      var endDate = end.slice(0, 10);
      if (startDate !== endDate) return;
      var endTimePart = end.length >= 19 ? end.slice(11, 19) : '';
      var isDefaultEndMidnight = endTimePart === '00:00:00';
      var sameInstant = start === end;
      if (!isDefaultEndMidnight && !sameInstant) return;
      var newEnd = "".concat(endDate, " 23:59:59");
      if (newEnd === end) return;
      this.$nextTick(function () {
        _this.detailQuery.dateRange = [start, newEnd];
      });
    },
    /** 接口字段与表格列对齐（ShopIntegralUserIntegralVO） */mapUserIntegralRow: function mapUserIntegralRow(item) {
      if (!item) return {};
      return _objectSpread(_objectSpread({}, item), {}, {
        customerId: item.customerId != null ? item.customerId : item.appId,
        name: item.nickname,
        phone: item.userPhone,
        availablePoints: item.remainIntegral,
        totalEarned: item.totalGainIntegral,
        totalConsumed: item.totalConsumeIntegral,
        totalRefundIntegral: item.totalRefundIntegral,
        totalRecycleIntegral: item.totalRecycleIntegral,
        sourceAppName: item.customerName != null && String(item.customerName).trim() !== '' ? item.customerName : item.appName
      });
    },
    loadList: function () {
      var _loadList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var data, list, limit, totalPage, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _shopIntegralApi.shopIntegralUserIntegralPageApi)({
                page: this.pageData.page,
                limit: this.pageData.limit,
                keyword: this.query.keyword,
                customerId: this.query.customerId
              });
            case 2:
              data = _context.v;
              list = data && data.list || [];
              this.serverTotal = data && data.total != null ? Number(data.total) : 0;
              this.tableData = list.map(function (row) {
                return _this2.mapUserIntegralRow(row);
              });
              limit = this.pageData.limit || 10;
              totalPage = (data && data.totalPage != null && data.totalPage !== '' ? Number(data.totalPage) : null) || Math.max(1, Math.ceil((this.serverTotal || 0) / limit));
              if (!(this.pageData.page > totalPage && totalPage >= 1)) {
                _context.n = 3;
                break;
              }
              this.pageData.page = totalPage;
              _context.n = 3;
              return this.loadList();
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.tableData = [];
              this.serverTotal = 0;
            case 5:
              _context.p = 5;
              this.listLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function loadList() {
        return _loadList.apply(this, arguments);
      }
      return loadList;
    }(),
    handleQuery: function handleQuery() {
      this.pageData.page = 1;
      this.loadList();
    },
    searchMiniAppOptions: function () {
      var _searchMiniAppOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(keyword) {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.miniAppLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword || ''
              });
            case 2:
              res = _context2.v;
              this.miniAppOptions = res || [];
            case 3:
              _context2.p = 3;
              this.miniAppLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 3, 4]]);
      }));
      function searchMiniAppOptions(_x) {
        return _searchMiniAppOptions.apply(this, arguments);
      }
      return searchMiniAppOptions;
    }(),
    handleReset: function handleReset() {
      this.query = {
        keyword: '',
        customerId: null,
        changeType: ''
      };
      this.pageData.page = 1;
      this.loadList();
    },
    mainTableIndexMethod: function mainTableIndexMethod(index) {
      return (this.pageData.page - 1) * this.pageData.limit + index + 1;
    },
    handleMainPageChange: function handleMainPageChange(page) {
      this.pageData.page = page;
      this.loadList();
    },
    handleMainSizeChange: function handleMainSizeChange(limit) {
      this.pageData.limit = limit;
      this.pageData.page = 1;
      this.loadList();
    },
    mapDetailStatToDetailUser: function mapDetailStatToDetailUser(data) {
      var d = data || {};
      var miniName = d.customerName != null && String(d.customerName).trim() !== '' ? d.customerName : d.appName != null && String(d.appName).trim() !== '' ? d.appName : '—';
      return {
        name: d.nickname != null && d.nickname !== '' ? d.nickname : '—',
        phone: d.userPhone != null && d.userPhone !== '' ? d.userPhone : '—',
        customerName: miniName,
        sourceAppName: miniName,
        availablePoints: d.remainIntegral != null ? d.remainIntegral : '—',
        pendingIntegral: d.pendingIntegral != null ? d.pendingIntegral : '—',
        totalEarned: d.totalGainIntegral != null ? d.totalGainIntegral : '—',
        totalConsumed: d.totalConsumeIntegral != null ? d.totalConsumeIntegral : '—',
        totalRefundIntegral: d.totalRefundIntegral != null ? d.totalRefundIntegral : '—',
        totalRecycleIntegral: d.totalRecycleIntegral != null ? d.totalRecycleIntegral : '—'
      };
    },
    /** 变动类型：1 获取 2 消耗 3 过期 4 退还 5 回收 */formatDetailIntegralDisplay: function formatDetailIntegralDisplay(row) {
      var v = row.integral;
      if (v == null && v !== 0) return '—';
      var n = Math.abs(Number(v));
      var t = Number(row.changeType);
      if (t === 1 || t === 4) {
        return "+".concat(n);
      }
      return "-".concat(n);
    },
    mapDetailRow: function mapDetailRow(item) {
      if (!item) return {};
      return _objectSpread(_objectSpread({}, item), {}, {
        changeTypeText: item.changeTypeDesc,
        changeValue: this.formatDetailIntegralDisplay(item),
        balanceAfter: item.afterIntegral,
        remark: item.description,
        changeTime: item.createTime,
        statusText: item.statusDesc
      });
    },
    loadDetailStat: function () {
      var _loadDetailStat = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$detailContext, customerId, userPhone, data, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _this$detailContext = this.detailContext, customerId = _this$detailContext.customerId, userPhone = _this$detailContext.userPhone;
              if (!(customerId == null || customerId === '' || !userPhone)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.detailStatLoading = true;
              _context3.p = 2;
              _context3.n = 3;
              return (0, _shopIntegralApi.shopIntegralUserIntegralDetailStatApi)({
                customerId: customerId,
                userPhone: userPhone
              });
            case 3:
              data = _context3.v;
              this.detailUser = this.mapDetailStatToDetailUser(data);
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t2 = _context3.v;
              this.detailUser = emptyDetailUser();
            case 5:
              _context3.p = 5;
              this.detailStatLoading = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function loadDetailStat() {
        return _loadDetailStat.apply(this, arguments);
      }
      return loadDetailStat;
    }(),
    loadDetailPage: function () {
      var _loadDetailPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this3 = this;
        var _this$detailContext2, customerId, userPhone, startTime, endTime, dr, data, list, limit, totalPage, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this$detailContext2 = this.detailContext, customerId = _this$detailContext2.customerId, userPhone = _this$detailContext2.userPhone;
              if (!(customerId == null || customerId === '' || !userPhone)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.detailDetailLoading = true;
              _context4.p = 2;
              dr = this.detailQuery.dateRange;
              if (dr && Array.isArray(dr) && dr.length === 2 && dr[0] && dr[1]) {
                startTime = dr[0];
                endTime = dr[1];
              }
              _context4.n = 3;
              return (0, _shopIntegralApi.shopIntegralUserIntegralDetailPageApi)({
                customerId: customerId,
                userPhone: userPhone,
                page: this.detailPage.page,
                limit: this.detailPage.limit,
                serialNo: this.detailQuery.serialKeyword,
                startTime: startTime,
                endTime: endTime,
                changeType: this.detailQuery.changeType
              });
            case 3:
              data = _context4.v;
              list = data && data.list || [];
              this.detailServerTotal = data && data.total != null ? Number(data.total) : 0;
              this.detailTableData = list.map(function (r) {
                return _this3.mapDetailRow(r);
              });
              limit = this.detailPage.limit || 10;
              totalPage = (data && data.totalPage != null && data.totalPage !== '' ? Number(data.totalPage) : null) || Math.max(1, Math.ceil((this.detailServerTotal || 0) / limit));
              if (!(this.detailPage.page > totalPage && totalPage >= 1)) {
                _context4.n = 4;
                break;
              }
              this.detailPage.page = totalPage;
              _context4.n = 4;
              return this.loadDetailPage();
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t3 = _context4.v;
              this.detailTableData = [];
              this.detailServerTotal = 0;
            case 6:
              _context4.p = 6;
              this.detailDetailLoading = false;
              return _context4.f(6);
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 5, 6, 7]]);
      }));
      function loadDetailPage() {
        return _loadDetailPage.apply(this, arguments);
      }
      return loadDetailPage;
    }(),
    openDetailDrawer: function () {
      var _openDetailDrawer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var customerId, userPhone;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              customerId = row.customerId != null ? row.customerId : row.appId;
              userPhone = row.userPhone != null && row.userPhone !== '' ? String(row.userPhone) : row.phone != null && row.phone !== '' ? String(row.phone) : '';
              if (!(customerId == null || customerId === '' || !userPhone)) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('缺少客户ID或手机号，无法查看积分明细');
              return _context5.a(2);
            case 1:
              this.detailContext = {
                customerId: Number(customerId),
                userPhone: userPhone
              };
              this.detailQuery = {
                serialKeyword: '',
                dateRange: null,
                changeType: null
              };
              this.detailPage = {
                page: 1,
                limit: 10
              };
              this.detailTableData = [];
              this.detailServerTotal = 0;
              this.detailUser = emptyDetailUser();
              this.detailVisible = true;
              _context5.n = 2;
              return this.loadDetailStat();
            case 2:
              _context5.n = 3;
              return this.loadDetailPage();
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function openDetailDrawer(_x2) {
        return _openDetailDrawer.apply(this, arguments);
      }
      return openDetailDrawer;
    }(),
    onDetailDrawerClose: function onDetailDrawerClose() {
      this.detailContext = {
        customerId: null,
        userPhone: ''
      };
      this.detailTableData = [];
      this.detailServerTotal = 0;
      this.detailPage = {
        page: 1,
        limit: 10
      };
      this.detailQuery = {
        serialKeyword: '',
        dateRange: null,
        changeType: null
      };
      this.detailUser = emptyDetailUser();
    },
    handleDetailQuery: function handleDetailQuery() {
      this.detailPage.page = 1;
      this.loadDetailPage();
    },
    handleDetailSizeChange: function handleDetailSizeChange(val) {
      this.detailPage.limit = val;
      this.detailPage.page = 1;
      this.loadDetailPage();
    },
    handleDetailPageChange: function handleDetailPageChange(val) {
      this.detailPage.page = val;
      this.loadDetailPage();
    }
  }
};